import { useLanguage } from '@/hooks/useLanguage';
import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import React from 'react';
import { Eye, Play, BarChart3 } from 'lucide-react';
import { getThumbnailUrl } from '@/utils/thumbnailUtils';

interface VideoDragPreviewProps {
  title: string;
  thumbnail?: string;
  views: number;
  plays: number;
}

/**
 * Ghost visual do card de vídeo enquanto ele é arrastado.
 * Renderizado dentro do <DragOverlay> do dnd-kit.
 */
export function VideoDragPreview({ title, thumbnail, views, plays }: VideoDragPreviewProps) {
  useLanguage();
  const formatNumber = (count: number) => {
    return count.toLocaleString(getInterfaceLanguage());
  };

  return (
    <div className="w-[200px] aspect-[16/9] rounded-[12px] overflow-hidden relative border-2 border-[#3478F6] shadow-[0_14px_32px_rgba(15,23,42,0.18)] opacity-[0.94] bg-[#0B1220]">
      {/* Thumbnail */}
      <div className="absolute inset-0 bg-muted overflow-hidden">
        {thumbnail ? (
          <img
            src={getThumbnailUrl(thumbnail, '640')}
            alt={title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#2D7FF9]/20 to-[#2D7FF9]/5 flex items-center justify-center">
            <BarChart3 className="w-6 h-6 text-[#2D7FF9]/40" />
          </div>
        )}

        {/* Faixa inferior com título e métricas */}
        <div
          className="absolute bottom-0 left-0 right-0 p-2.5 pt-8"
          style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%)' }}
        >
          <h3 className="text-[11px] font-semibold text-white truncate">
            {title}
          </h3>
          <div className="flex items-center gap-x-2 mt-0.5 opacity-80">
            <div className="flex items-center gap-0.5">
              <Eye className="w-[10px] h-[10px] text-white" strokeWidth={2} />
              <span className="text-[9px] text-white font-medium">
                {formatNumber(views)}
              </span>
            </div>
            <div className="flex items-center gap-0.5">
              <Play className="w-[10px] h-[10px] text-white" strokeWidth={2} />
              <span className="text-[9px] text-white font-medium">
                {formatNumber(plays)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
